import React from 'react';
import { Modal, Form, Input, Select, Checkbox, Button, Row, Col } from 'antd';

const { Option } = Select;

const CreateCustomerModal = ({ visible, onCancel, onSave }) => {
    const [form] = Form.useForm();

    const handleSave = () => {
        form.validateFields().then(values => {
            onSave(values);
            form.resetFields();
        }).catch(info => {
            console.log('Validate Failed:', info);
        });
    };

    return (
        <Modal
            open={visible}
            title={<span style={{ fontWeight: 600, fontSize: '16px' }}>Create Customer's Address</span>}
            onCancel={onCancel}
            footer={[
                <Button key="submit" type="primary" onClick={handleSave} style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', borderRadius: '4px' }}>
                    Save Address
                </Button>
            ]}
            width={700}
        >
            <Form form={form} layout="vertical" >
                <Row gutter={16}>
                    <Col span={24} md={12}>
                        <Form.Item name="companyName" label={<span style={{ fontWeight: 500 }}>Institution/Company Name</span>}>
                            <Input placeholder="Company Name" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                        <Form.Item name="vatId" label={<span style={{ fontWeight: 500 }}>Vat ID</span>}>
                            <Input placeholder="Vat ID" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={8}>
                        <Form.Item name="firstName" label={<span style={{ fontWeight: 500 }}>First Name</span>} rules={[{ required: true, message: 'Please input first name!' }]}>
                            <Input placeholder="First Name" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={8}>
                        <Form.Item name="middleName" label={<span style={{ fontWeight: 500 }}>Middle Name</span>} >
                            <Input placeholder="Middle Name" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={8}>
                        <Form.Item name="lastName" label={<span style={{ fontWeight: 500 }}>Last Name</span>} rules={[{ required: true, message: 'Please input last name!' }]}>
                            <Input placeholder="Last Name" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item name="streetAddress" label={<span style={{ fontWeight: 500 }}>Street Address</span>} rules={[{ required: true, message: 'Please input street address!' }]}>
                            <Input placeholder="Street Address" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>

                    <Col span={24} md={12}>
                        <Form.Item name="city" label={<span style={{ fontWeight: 500 }}>City</span>} rules={[{ required: true, message: 'Please input city!' }]}>
                            <Input placeholder="City" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                        <Form.Item name="postCode" label={<span style={{ fontWeight: 500 }}>Post Code</span>} rules={[{ required: true, message: 'Please input post code!' }]}>
                            <Input placeholder="Post Code" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24} md={12}>
                        <Form.Item name="country" label={<span style={{ fontWeight: 500 }}>Country</span>} rules={[{ required: true, message: 'Please select country!' }]}>
                            <Select placeholder="Country" style={{ borderRadius: '6px' }}>
                                <Option value="us">United States</Option>
                                <Option value="uk">United Kingdom</Option>
                                <Option value="in">India</Option>
                                <Option value="ca">Canada</Option>
                                <Option value="au">Australia</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                        <Form.Item name="state" label={<span style={{ fontWeight: 500 }}>State</span>} rules={[{ required: true, message: 'Please input state!' }]}>
                            <Input placeholder="State" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24} md={12}>
                        <Form.Item name="phone" label={<span style={{ fontWeight: 500 }}>Phone</span>} rules={[{ required: true, message: 'Please input phone!' }]}>
                            <Input placeholder="Phone" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                    <Col span={24} md={12}>
                        <Form.Item name="email" label={<span style={{ fontWeight: 500 }}>Email</span>} rules={[{ required: true, message: 'Please input email!', type: 'email' }]}>
                            <Input placeholder="Email" style={{ borderRadius: '6px' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="defaultAddress" valuePropName="checked" style={{ marginBottom: 0 }}>
                            <Checkbox><span style={{ color: '#475569' }}>Default Address</span></Checkbox>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default CreateCustomerModal;
